var _defs, _g, _g2, _circle, _circle2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenitizeLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 59.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        opacity: .9;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4, .cls-2, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        opacity: .6;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: #51b3d8;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.57,
    y1: 24.15,
    x2: 47.26,
    y2: 24.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447ff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#51b3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.57,
    y1: 40.65,
    x2: 47.26,
    y2: 40.65,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.26 39.17 47.26 19.14 29.92 9.13 12.57 19.14 12.57 39.17 29.92 29.21 47.26 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.91 30.66 12.57 40.63 29.91 50.64 47.26 40.63 29.91 30.66"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.92 9.13 29.92 29.21 12.57 39.17 29.92 9.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "47.26 39.17 29.92 29.21 29.92 9.13 47.26 39.17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.57,22.62h-4.6v16.28h-3.37v-16.28h-4.6v-3.18h12.58v3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.18,31.97c0-3.97,3.1-7.21,7.45-7.21s7.4,3.23,7.4,7.21-3.07,7.21-7.4,7.21-7.45-3.23-7.45-7.21ZM81.67,31.97c0-2.19-1.67-4.03-4.03-4.03s-4.08,1.84-4.08,4.03,1.7,4.03,4.08,4.03,4.03-1.84,4.03-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.39,31.06l6.3,7.84h-4.19l-4.49-5.56-2.08,1.97v3.59h-3.37v-20.55h3.37v12.44l6.06-5.75h4.71l-6.3,6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.77,33.01h-10.5c.08,1.7,1.37,3.18,3.81,3.18,1.75,0,2.88-.93,3.43-1.89l2.96.33c-.41,1.89-2.58,4.55-6.41,4.55-4.28,0-7.15-3.23-7.15-7.29s2.74-7.12,6.93-7.12,6.93,3.4,6.93,7.37v.88ZM105.28,30.68h7.13c-.11-1.53-1.45-2.93-3.56-2.93s-3.48,1.34-3.56,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.64,30.71v8.19h-3.37v-6.63c0-3.23-1.18-4.33-3.04-4.33-2.36,0-3.75,1.78-3.84,4.03v6.93h-3.37v-13.87h3.18l.16,2.06c1.34-1.34,3.1-2.33,5.18-2.33,3.34,0,5.1,2.17,5.1,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.77,38.9h-3.37v-13.87h3.37v13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.32,28.21h-3.07v10.69h-3.37v-10.69h-2.17v-3.18h2.17v-4.11h3.37v4.11h3.07v3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.75,38.9h-3.37v-13.87h3.37v13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.63,29.96l-7.29,5.76h7.29v3.18h-11.84v-3.18l7.29-5.76h-7.29v-3.18h11.84v3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.19,33.01h-10.5c.08,1.7,1.37,3.18,3.81,3.18,1.75,0,2.88-.93,3.43-1.89l2.96.33c-.41,1.89-2.58,4.55-6.41,4.55-4.28,0-7.15-3.23-7.15-7.29s2.74-7.12,6.93-7.12,6.93,3.4,6.93,7.37v.88ZM173.69,30.68h7.13c-.11-1.53-1.45-2.93-3.56-2.93s-3.48,1.34-3.56,2.93Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 152.07,
    cy: 21.77,
    r: 1.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 136.1,
    cy: 21.77,
    r: 1.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "162.71 19.4 159.46 25.03 162.71 23.17 165.95 25.03 162.71 19.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenitizeLogo2);
export default __webpack_public_path__ + "static/media/Tokenitize_logo 2.abc21929b53541b6a4ed0220c9f66199.svg";
export { ForwardRef as ReactComponent };